import { ReferenceMapping } from '@/services/http/wap/types'

export const LOCATION_MAPPING: ReferenceMapping[] = [
  {
    name: 'title',
    path: 'baslik',
    type: 'query',
  },
  {
    name: 'location',
    path: 'lokasyon',
    type: 'query',
  },
  {
    name: 'lat',
    path: 'latitude',
    type: 'query',
  },
  {
    name: 'lng',
    path: 'longitude',
    type: 'query',
  },
  {
    name: 'address',
    path: 'adres',
    type: 'query',
  },
  {
    name: 'directions',
    path: 'adresTarifi',
    type: 'query',
  },
  {
    name: 'chargingType',
    path: 'sarjTurleri',
    type: 'query',
    children: [
      {
        name: 'title',
        path: 'sarjTurleri.baslik',
        type: 'query',
      },
      {
        name: 'icon',
        path: 'sarjTurleri.icon',
        type: 'query',
      },
    ],
  },
]
